import React from 'react';
import logo from "../../assets/images/logo.svg";
import classNames from 'classnames';

type LogoProps = {
  className?: string;
};

const Logo: React.FC<LogoProps> = ({className}) => {

  return (
      <img src={logo} alt="Prime Oasis AI" className={classNames("logo", className)} />
  );
};

export default Logo;
